import { render, staticRenderFns } from "./ModalTesting.vue?vue&type=template&id=7d4d9c74&"
import script from "./ModalTesting.vue?vue&type=script&lang=js&"
export * from "./ModalTesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports